import React from 'react';
import PropTypes from 'prop-types';

const FinalBlockData = function (key, colSpanOfTwelve, { blockWrapperClasses, content }) {
  this.key = key;
  this.colSpanOfTwelve = colSpanOfTwelve;
  this.blockWrapperClasses = blockWrapperClasses;
  this.content = content;
};

const TwoThirds = ({
  smallerBlock,
  biggerBlock,
  isSmallerBlockLast,
  swapBlocksBeyondBreakpoint,
  layoutBreakpoint,
  wrapperClasses = []
}) => {
  const breakpointPrefix = layoutBreakpoint ? `${layoutBreakpoint}-` : '';
  const smallerBlockData = new FinalBlockData('smaller', 4, smallerBlock);
  const biggerBlockData = new FinalBlockData('bigger', 8, biggerBlock);

  const getFinalClassName = function (initialClassArray = [], colSpanOfTwelve) {
    return [
      ...initialClassArray,
      `col-${breakpointPrefix}${colSpanOfTwelve}`,
      'grid-gap-col'
    ].join(' ');
  };

  const elementArrangement = !isSmallerBlockLast
    ? [smallerBlockData, biggerBlockData]
    : [biggerBlockData, smallerBlockData];

  wrapperClasses.push(`d-${breakpointPrefix}flex`);

  if (swapBlocksBeyondBreakpoint) {
    wrapperClasses.push('flex-row-reverse');
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      {elementArrangement.map(({ blockWrapperClasses, colSpanOfTwelve, content, key }) => (
        <div className={getFinalClassName(blockWrapperClasses, colSpanOfTwelve)} key={key}>
          {content}
        </div>
      ))}
    </div>
  );
};

const blockPropTypes = {
  blockWrapperClasses: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.element.isRequired
};

TwoThirds.propTypes = {
  smallerBlock: PropTypes.shape(blockPropTypes).isRequired,
  biggerBlock: PropTypes.shape(blockPropTypes).isRequired,
  wrapperClasses: PropTypes.arrayOf(PropTypes.string),
  isSmallerBlockLast: PropTypes.bool,
  swapBlocksBeyondBreakpoint: PropTypes.bool,
  layoutBreakpoint: PropTypes.oneOf([
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
  ])
};

export default TwoThirds;